import React from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  SCHOOL_DENTAL_RECORD_DETAILS_PATH,
  SCHOOL_DENTAL_RECORDS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';

const SchoolDentalRecordsPage = React.lazy(() => import('./pages/SchoolDentalRecordsPage/SchoolDentalRecordsPage'));
const SchoolDentalRecordDetailsPage = React.lazy(
  () => import('./pages/SchoolDentalRecordDetailsPage/SchoolDentalRecordDetailsPage')
);

export const SCHOOL_DENTAL_RECORDS_ROUTES = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SchoolDentalRecordsPage />,
    displayTitle: () => 'School Dental Records',
    pageType: PageType.PRIVATE,
    path: SCHOOL_DENTAL_RECORDS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.schoolDentalRecords,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SchoolDentalRecordDetailsPage />,
    displayTitle: () => 'School Dental Records Details',
    pageType: PageType.PRIVATE,
    path: SCHOOL_DENTAL_RECORD_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.schoolDentalRecords,
  },
];
